import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function SurveyList() {
  const navigate = useNavigate();
  const [surveys, setSurveys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadSurveys();
  }, []);

  const loadSurveys = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/surveys`);
      setSurveys(response.data);
      setLoading(false);
    } catch (err) {
      setError('Failed to load forms: ' + err.message);
      setLoading(false);
    }
  };

  const handleDelete = async (id, title) => {
    if (!window.confirm(`Are you sure you want to delete "${title}"?`)) {
      return;
    }

    try {
      await axios.delete(`${API_URL}/surveys/${id}`);
      setSurveys(surveys.filter(s => s._id !== id));
    } catch (err) {
      alert('Failed to delete from: ' + err.message);
    }
  };

  const copyLink = (id) => {
    const link = `${window.location.origin}/survey/${id}`;
    navigator.clipboard.writeText(link);
    alert('Form link copied to clipboard!');
  };

  if (loading) {
    return <div className="loading">Loading forms...</div>;
  }

  return (
    <div>
      <div className="container">
        <div className="flex-between" style={{ marginBottom: '1.5rem' }}>
          <div>
            <h1 className="page-title">Forms</h1>
            <p className="page-subtitle">Create and manage your Forms</p>
          </div>
          <button 
            onClick={() => navigate('/builder')} 
            className="button"
          >
            ➕ Create New
          </button>
        </div>

        {error && <div className="error">{error}</div>}
      </div>

      {surveys.length === 0 ? (
        <div className="container empty-state">
          <div className="empty-state-icon">📋</div>
          <h2>No Forms yet</h2>
          <p>Create your first form to get started</p>
          <button 
            onClick={() => navigate('/builder')} 
            className="button" 
            style={{ marginTop: '1rem' }}
          >
            Create Form
          </button>
        </div>
      ) : (
        surveys.map((survey) => (
          <div key={survey._id} className="container">
            <h3 className="card-title">{survey.title}</h3>
            {survey.description && (
              <p className="card-text">{survey.description}</p>
            )}
            <p style={{ fontSize: '0.85rem', color: '#95a5a6', marginBottom: '1rem' }}>
              Created: {new Date(survey.createdAt).toLocaleDateString()}
              {survey.updatedAt !== survey.createdAt && (
                <> • Updated: {new Date(survey.updatedAt).toLocaleDateString()}</>
              )}
            </p>
            
            <div className="card-actions">
              <button 
                onClick={() => navigate(`/survey/${survey._id}`)} 
                className="button button-success button-small"
              >
                📝 Take Form
              </button>
              <button 
                onClick={() => navigate(`/builder/${survey._id}`)} 
                className="button button-small"
              >
                ✏️ Edit
              </button>
              <button 
                className="button button-small button-secondary"
                onClick={() => copyLink(survey._id)}
              >
                🔗 Copy Link
              </button>
              <button 
                onClick={() => navigate(`/responses?surveyId=${survey._id}`)} 
                className="button button-small button-secondary"
              >
                📊 Responses
              </button>
              <button 
                className="button button-small button-danger"
                onClick={() => handleDelete(survey._id, survey.title)}
              >
                🗑️ Delete
              </button>
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default SurveyList;
